import Stock  from './views/Stock'
import Stocks from './views/Stocks'
import Tracking from './views/Tracking'
import Freights from  './views/Freight'
import StockWorkers from  './views/StockWorkers'
import StockWorker  from  './views/StockWorker'
import FreightsTracking from  './views/FreightTracking'
import TrackingStatuses from  './views/TrackingStatuses'
import TrackingStatus   from  './views/TrackingStatus'
//import ItineraryFreights from './views/ItineraryFreights'
//import Itineraries from './views/Itineraries'
//import Itinerary from './views/Itinerary'
import Printers from './views/Printers';
import Printer  from './views/Printer';


export default {
  routes: [
    {
      path: '/module/stock',
      name: 'Stocks',
      component: Stocks,
      meta: {tab: 'stock', toolbars: ['Search']}
    },
    {
      path: '/module/stock/:stock_id',
      name: 'Stock',
      components: {default: Stocks, right: Stock},
      meta: {tab: 'stock', toolbars: ['Search']}
    },

    {
      path: '/module/tracking-statuses',
      name: 'TrackingStatuses',
      components: { default: TrackingStatuses },
      meta: {tab: 'freight-statuses', setting_link: 'TrackingStatuses'}
    },
    {
      path: '/module/tracking-statuses/:id',
      name: 'TrackingStatus',
      components: {default: TrackingStatuses, right: TrackingStatus},
      meta: {tab: 'freight-statuses', setting_link: 'TrackingStatuses'}
    },
    
    {
      path: '/module/stock/:stock_id/tracking',
      name: 'Tracking',
      component: Tracking,
      meta: {tab: 'stock'}
    },
    {
      path: '/module/freight',
      name: 'Freights',
      component: Freights,
      meta: {tab: 'freight', toolbars: ['FreightSearch']}
    },


    {
      path: '/module/stock-printers',
      name: 'Printers',
      component: Printers,
      meta: {setting_link: 'Printers',  toolbars: ['Printer']}
    },
    {
      path: '/module/stock-printers/:id',
      name: 'Printer',
      components: {default: Printers, right: Printer},
      meta: {setting_link: 'Printers', toolbars: ['Printer']}
    },


    /*{
      path: '/module/freight/itinerary',
      name: 'ItineraryFreights',
      components: {default: Freights, right: ItineraryFreights},
      meta: {tab: 'freight', toolbars: ['FreightSearch'], setting_link: 'Freights'}
    },
    {
      path: '/module/freight/itineraries',
      name: 'Itineraries',
      component: Itineraries,
      meta: {tab: 'itineraries', setting_link: 'Freights'}
    },
    {
      path: '/module/freight/itineraries/itinerary',
      name: 'Itinerary',
      components: {default: Itineraries, right: Itinerary},
      meta: {tab: 'itineraries', setting_link: 'Freights'}
    },*/


    {
      path: '/module/freight/:freight_id/tracking',
      name: 'FreightsTracking',
      component: FreightsTracking,
      meta: {tab: 'freight'}
    },
    {
      path: '/module/stock/:stock_id/workers',
      name: 'StockWorkers',
      components: { default: StockWorkers },
      meta: {tab: 'stock'}
    },
    {
      path: '/module/stock/:stock_id/workers/:id',
      name: 'StockWorker',
      components: {default: StockWorkers, right: StockWorker},
      meta: {tab: 'stock'}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/modules/stock/routes.js